import { ValidatorFn, AbstractControl } from '@angular/forms';

// The validation algorithm is based on https://no.wikipedia.org/wiki/F%C3%B8dselsnummer
// Copied from https://bitbucket.ice.local/projects/BF/repos/self-service/browse/source/src/app/shared/validation/valid-ssn.directive.ts

export function ssnValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const ssn = control.value.toString();

    if (!ssn) {
      return null;
    }

    // Check length
    if (!/^\d{11}$/.test(ssn)) {
      return { ssnInvalid: true };
    }

    // Reject all zeros
    if (/^0+$/.test(ssn)) {
      return { ssnInvalid: true };
    }

    // Split SSN for control checks
    const d1 = parseInt(ssn[0], 10);
    const d2 = parseInt(ssn[1], 10);
    const m1 = parseInt(ssn[2], 10);
    const m2 = parseInt(ssn[3], 10);
    const y1 = parseInt(ssn[4], 10);
    const y2 = parseInt(ssn[5], 10);
    const i1 = parseInt(ssn[6], 10);
    const i2 = parseInt(ssn[7], 10);
    const i3 = parseInt(ssn[8], 10);
    const c1 = parseInt(ssn[9], 10);
    const c2 = parseInt(ssn[10], 10);

    // Calculate control check c1
    let c1calc = 11 - ((3 * d1 + 7 * d2 + 6 * m1 + m2 + 8 * y1 + 9 * y2 + 4 * i1 + 5 * i2 + 2 * i3) % 11);

    if (c1calc === 11) {
      c1calc = 0;
    }

    if (c1calc === 10) {
      return { ssnInvalid: true };
    }

    if (c1 !== c1calc) {
      return { ssnInvalid: true };
    }

    // Calculate control check c2
    let c2calc = 11 - ((5 * d1 + 4 * d2 + 3 * m1 + 2 * m2 + 7 * y1 + 6 * y2 + 5 * i1 + 4 * i2 + 3 * i3 + 2 * c1calc) % 11);

    if (c2calc === 11) {
      c2calc = 0;
    }

    if (c2calc === 10) {
      return { ssnInvalid: true };
    }

    if (c2 !== c2calc) {
      return { ssnInvalid: true };
    }

    return null;
  };
}
